export const CANNOT_ARCHIVE_TRAILER_WITH_ROUTES = "Cannot archive trailer that has routes assigned";
export const CANNOT_CREATE_TRAILER_WITH_DUPLICATE_VIN = "Cannot create trailer with duplicate VIN";
export const ERR_DUPLICATE_VIN = "ERR_DUPLICATE_VIN";
export const ERR_CHANGE_ECONOMIC_TOKEN = "ERR_CHANGE_ECONOMIC_TOKEN";
export const DUPLICATE_EQUIPMENT_NUMBER = "DUPLICATE_EQUIPMENT_NUMBER";
export const DUPLICATE_EQUIPMENT_TYPE_NAME = "DUPLICATE_EQUIPMENT_TYPE_NAME";
export const EQUIPMENT_TYPE_HAS_EQUIPMENT = "EQUIPMENT_TYPE_HAS_EQUIPMENT";
export const DUPLICATE_EQUIPMENT_DEPOT_NAME = "DUPLICATE_EQUIPMENT_DEPOT_NAME";
export const EQUIPMENT_DEPOT_HAS_EQUIPMENT = "EQUIPMENT_DEPOT_HAS_EQUIPMENT";
export const DUPLICATE_FRACTION_NAME = "DUPLICATE_FRACTION_NAME";
export const DUPLICATE_USER_EMAIL = "DUPLICATE_USER_EMAIL";
export const ERR_CANNOT_DELETE_STOP_WITH_EVENTS = "ERR_CANNOT_DELETE_STOP_WITH_EVENTS";
export const ERR_OUTDATED_CARGO_REVISION = "ERR_OUTDATED_CARGO_REVISION";
export const ERR_CANNOT_MOVE_CARGO_TO_ARCHIVED_ROUTE = "ERR_CANNOT_MOVE_CARGO_TO_ARCHIVED_ROUTE";
export const ERR_CANNOT_MOVE_CARGO_FROM_ARCHIVED_ROUTE = "ERR_CANNOT_MOVE_CARGO_FROM_ARCHIVED_ROUTE";
export const ERR_DUPLICATE_EXTRA_CO2_TYPE = "ERR_DUPLICATE_EXTRA_CO2_TYPE";
export const ERR_EXTRA_CO2_TYPE_IN_USE = "ERR_EXTRA_CO2_TYPE_IN_USE";
export const ERR_DELETED_EXTRA_CO2_TYPES = "ERR_DELETED_EXTRA_CO2_TYPES";
export const ERR_STOP_ORDER_NOT_POSSIBLE = "ERR_STOP_ORDER_NOT_POSSIBLE";
export const ERR_CARGOS_FILE_UPLOAD__NO_WORKSHEET_FOUND = "ERR_CARGOS_FILE_UPLOAD__NO_WORKSHEET_FOUND";
export const ERR_CARGOS_FILE_UPLOAD__NO_ROWS_FOUND = "ERR_CARGOS_FILE_UPLOAD__NO_ROWS_FOUND";
export const ERR_CARGOS_FILE_UPLOAD__NO_HEADERS = "ERR_CARGOS_FILE_UPLOAD__NO_HEADERS";
export const ERR_CARGOS_FILE_UPLOAD__MISSING_COLUMN = "ERR_CARGOS_FILE_UPLOAD__MISSING_COLUMN";
export const ERR_CARGOS_FILE_UPLOAD__MISSING_ORG_COORDS = "ERR_CARGOS_FILE_UPLOAD__MISSING_ORG_COORDS";
export const ERR_CARGOS_FILE_UPLOAD__CLIENT_NOT_FOUND = "ERR_CARGOS_FILE_UPLOAD__CLIENT_NOT_FOUND";
export const ERR_CARGOS_FILE_UPLOAD__INVALID_DATE = "ERR_CARGOS_FILE_UPLOAD__INVALID_DATE";
export const ERR_CARGOS_FILE_UPLOAD__INVALID_LOADMETERS = "ERR_CARGOS_FILE_UPLOAD__INVALID_LOADMETERS";
export const ERR_CARGOS_FILE_UPLOAD__INVALID_WEIGHT = "ERR_CARGOS_FILE_UPLOAD__INVALID_WEIGHT";
export const ERR_CARGOS_FILE_UPLOAD__INVALID_VOLUME = "ERR_CARGOS_FILE_UPLOAD__INVALID_VOLUME";
export const ERR_CARGOS_FILE_UPLOAD__MISSING_POSTCODE_CITY = "ERR_CARGOS_FILE_UPLOAD__MISSING_POSTCODE_CITY";
export const ERR_CARGOS_FILE_UPLOAD__MISSING_ADDRESS = "ERR_CARGOS_FILE_UPLOAD__MISSING_ADDRESS";
export const ERR_CARGOS_FILE_UPLOAD__GEOCODE_FAILED = "ERR_CARGOS_FILE_UPLOAD__GEOCODE_FAILED";
export const ERR_CARGOS_FILE_UPLOAD__CREATE_CARGO_FAILED = "ERR_CARGOS_FILE_UPLOAD__CREATE_CARGO_FAILED";
export const ERR_CARGOS_FILE_UPLOAD__MISSING_COUNTRY = "ERR_CARGOS_FILE_UPLOAD__MISSING_COUNTRY";
export const ERR_ROUTES_STOPS_DATA_CORRUPTION = "ERR_ROUTES_STOPS_DATA_CORRUPTION";
export const INVALID_DATE = "INVALID_DATE";
export const END_DATE_BEFORE_START_DATE = "END_DATE_BEFORE_START_DATE";
export const UNKNOWN_CLIENT = "UNKNOWN_CLIENT";
export const RENTAL_NEEDS_EQUIPMENT = "RENTAL_NEEDS_EQUIPMENT";
export const RENTAL_IS_CANCELLED = "RENTAL_IS_CANCELLED";
export const RENTAL_ALREADY_INVOICED = "RENTAL_ALREADY_INVOICED";
export const RENTAL_CANNOT_DELIVER = "RENTAL_CANNOT_DELIVER";
export const RENTAL_CANNOT_RETURN = "RENTAL_CANNOT_RETURN";
export const RENTAL_CANNOT_CANCEL = "RENTAL_CANNOT_CANCEL";
export const HAND_OVER_DATE_IN_FUTURE = "HAND_OVER_DATE_IN_FUTURE";
export const HAND_OVER_BEFORE_START = "HAND_OVER_BEFORE_START";
export const RENTAL_ACTIVE_CANNOT_DELETE = "RENTAL_ACTIVE_CANNOT_DELETE";
export const EQUIPMENT_LISTED_TWICE = "EQUIPMENT_LISTED_TWICE";
export const EQUIPMENT_NOT_ON_RENTAL = "EQUIPMENT_NOT_ON_RENTAL";
export const EQUIPMENT_MISSING_FROM_UPDATE = "EQUIPMENT_MISSING_FROM_UPDATE";
export const EQUIPMENT_NOT_AVAILABLE = "EQUIPMENT_NOT_AVAILABLE";
export const EQUIPMENT_INSUFFICIENT_QUANTITY = "EQUIPMENT_INSUFFICIENT_QUANTITY";
export const EQUIPMENT_CANNOT_ARCHIVE_STATUS = "EQUIPMENT_CANNOT_ARCHIVE_STATUS";
export const EQUIPMENT_ON_ACTIVE_RENTAL = "EQUIPMENT_ON_ACTIVE_RENTAL";
export const EQUIPMENT_SOLD_CANNOT_CHANGE_STATUS = "EQUIPMENT_SOLD_CANNOT_CHANGE_STATUS";
export const EQUIPMENT_BULK_NOT_SUPPORTED_FOR_JOB = "EQUIPMENT_BULK_NOT_SUPPORTED_FOR_JOB";
export const EQUIPMENT_NOT_WITH_CUSTOMER = "EQUIPMENT_NOT_WITH_CUSTOMER";
export const EQUIPMENT_TYPE_CANNOT_BE_EMPTIED = "EQUIPMENT_TYPE_CANNOT_BE_EMPTIED";
export const EQUIPMENT_HAS_NO_TYPE = "EQUIPMENT_HAS_NO_TYPE";
export const EQUIPMENT_HAS_NO_CLIENT = "EQUIPMENT_HAS_NO_CLIENT";
export const EQUIPMENT_HAS_NO_CUSTOMER_LOCATION = "EQUIPMENT_HAS_NO_CUSTOMER_LOCATION";
export const EQUIPMENT_HAS_NO_HOME_LOCATION = "EQUIPMENT_HAS_NO_HOME_LOCATION";
export const EQUIPMENT_RENTAL_ERROR_CODES = [
    INVALID_DATE,
    END_DATE_BEFORE_START_DATE,
    UNKNOWN_CLIENT,
    RENTAL_NEEDS_EQUIPMENT,
    RENTAL_IS_CANCELLED,
    RENTAL_ALREADY_INVOICED,
    RENTAL_CANNOT_DELIVER,
    RENTAL_CANNOT_RETURN,
    RENTAL_CANNOT_CANCEL,
    HAND_OVER_DATE_IN_FUTURE,
    HAND_OVER_BEFORE_START,
    RENTAL_ACTIVE_CANNOT_DELETE,
    EQUIPMENT_LISTED_TWICE,
    EQUIPMENT_NOT_ON_RENTAL,
    EQUIPMENT_MISSING_FROM_UPDATE,
    EQUIPMENT_NOT_AVAILABLE,
    EQUIPMENT_INSUFFICIENT_QUANTITY,
    EQUIPMENT_CANNOT_ARCHIVE_STATUS,
    EQUIPMENT_ON_ACTIVE_RENTAL,
    EQUIPMENT_SOLD_CANNOT_CHANGE_STATUS,
    EQUIPMENT_BULK_NOT_SUPPORTED_FOR_JOB,
    EQUIPMENT_NOT_WITH_CUSTOMER,
    EQUIPMENT_TYPE_CANNOT_BE_EMPTIED,
    EQUIPMENT_HAS_NO_TYPE,
    EQUIPMENT_HAS_NO_CLIENT,
    EQUIPMENT_HAS_NO_CUSTOMER_LOCATION,
    EQUIPMENT_HAS_NO_HOME_LOCATION,
];
export const ECONOMIC_CUSTOMER_DEFAULTS_MISSING = "ECONOMIC_CUSTOMER_DEFAULTS_MISSING";
export const ECONOMIC_CUSTOMER_NUMBER_OUT_OF_RANGE = "ECONOMIC_CUSTOMER_NUMBER_OUT_OF_RANGE";
export const ECONOMIC_MAX_CUSTOMER_NUMBER = 999999999;
export const ECONOMIC_CUSTOMER_EMAIL_TOO_LONG = "ECONOMIC_CUSTOMER_EMAIL_TOO_LONG";
export const ECONOMIC_CUSTOMER_EMAIL_MAX_LENGTH = 255;
export const ECONOMIC_CUSTOMER_REJECTED = "ECONOMIC_CUSTOMER_REJECTED";
export const ECONOMIC_CUSTOMER_ERROR_CODES = [
    ECONOMIC_CUSTOMER_DEFAULTS_MISSING,
    ECONOMIC_CUSTOMER_NUMBER_OUT_OF_RANGE,
    ECONOMIC_CUSTOMER_EMAIL_TOO_LONG,
    ECONOMIC_CUSTOMER_REJECTED,
];
//# sourceMappingURL=api-errors.js.map